import type { OnChanges } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { FontColor, TextSize } from '@freelancer/ui/text';
import { RatingTextColor } from '../rating/rating.types';
import { ReviewCountSize } from './review-count.types';

@Component({
  selector: 'fl-review-count',
  template: `
    <fl-icon
      [name]="'ui-rate-review-v3'"
      [disabled]="counter === 0"
      [size]="size"
      [sizeTablet]="sizeTablet"
      [sizeDesktop]="sizeDesktop"
      [sizeDesktopLarge]="sizeDesktopLarge"
      [color]="IconColor.ORANGE_XDARK"
      [flMarginRight]="'xxxsmall'"
    ></fl-icon>
    <fl-text
      [size]="reviewTextSize"
      [sizeTablet]="reviewTextSizeTablet"
      [sizeDesktop]="reviewTextSizeDesktop"
      [sizeDesktopLarge]="reviewTextSizeDesktopLarge"
      [color]="
        textColor === 'foreground' ? FontColor.FOREGROUND : FontColor.LIGHT
      "
    >
      {{ counter }}
    </fl-text>
  `,
  styleUrls: ['./review-count.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewCountComponent implements OnChanges {
  IconColor = IconColor;
  IconSize = IconSize;
  TextSize = TextSize;
  FontColor = FontColor;

  reviewTextSize: TextSize = TextSize.SMALL;
  reviewTextSizeTablet?: TextSize | undefined;
  reviewTextSizeDesktop?: TextSize | undefined;
  reviewTextSizeDesktopLarge?: TextSize | undefined;

  @Input() counter = 0;
  @Input() textColor: RatingTextColor = 'foreground';

  @HostBinding('attr.data-size')
  @Input()
  size: ReviewCountSize = IconSize.MID;

  /** Change the [size] from tablet and above */
  @HostBinding('attr.data-size-tablet')
  @Input()
  sizeTablet?: ReviewCountSize;

  /** Change the [size] from desktop and above */
  @HostBinding('attr.data-size-desktop')
  @Input()
  sizeDesktop?: ReviewCountSize;

  @HostBinding('attr.data-size-desktop-lage')
  @Input()
  sizeDesktopLarge?: ReviewCountSize;

  ngOnChanges(): void {
    switch (this.size) {
      case IconSize.SMALL:
        this.reviewTextSize = TextSize.XXSMALL;
        break;
      default:
        this.reviewTextSize = TextSize.SMALL;
    }

    switch (this.sizeTablet) {
      case IconSize.SMALL:
        this.reviewTextSizeTablet = TextSize.XXSMALL;
        break;
      case IconSize.MID:
        this.reviewTextSizeTablet = TextSize.SMALL;
        break;
      default:
        this.reviewTextSizeTablet = undefined;
    }

    switch (this.sizeDesktop) {
      case IconSize.SMALL:
        this.reviewTextSizeDesktop = TextSize.XXSMALL;
        break;
      case IconSize.MID:
        this.reviewTextSizeDesktop = TextSize.SMALL;
        break;
      default:
        this.reviewTextSizeDesktop = undefined;
    }

    switch (this.sizeDesktopLarge) {
      case IconSize.SMALL:
        this.reviewTextSizeDesktopLarge = TextSize.XXSMALL;
        break;
      case IconSize.MID:
        this.reviewTextSizeDesktopLarge = TextSize.SMALL;
        break;
      default:
        this.reviewTextSizeDesktopLarge = undefined;
    }
  }
}
